import React from 'react';
import PropTypes from 'prop-types';

/**
 *
 * @return {JSX.Element}
 * @constructor
 */
export default function DesktopLayout({children}) {
  return <div className="Avada_PreviewDesktop__Screen">{children}</div>;
}

DesktopLayout.propTypes = {
  children: PropTypes.any
};
